import { Link, Outlet } from 'react-router-dom';
import { Fragment } from 'react';
import { toAbsoluteUrl } from '@/utils';
import useBodyClasses from '@/hooks/useBodyClasses';
import { AuthBrandedLayoutProvider } from './AuthBrandedLayoutProvider';
import LanguageSwitcher from '@/components/LanguageSwitcher';
const Layout = () => {
  useBodyClasses('dark:bg-coal-500');
  return <Fragment>
      <style>
        {`
          .branded-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1600/bg-10.png')}');
            background-size: cover;
            background-size: 180% auto;
            background-position: center;
            background-repeat: no-repeat;
            min-height: 100vh;
          }
          @media (max-width: 1023px) {
            .branded-bg {
              background-size: 500% auto;
            }
          }
          .dark .branded-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1600/bg-10.png')}');
          }
        `}
      </style>

      <div className="grid lg:grid-cols grow branded-bg relative min-h-screen">
        <div className="flex justify-center items-center p-8 lg:p-10 w-full">
          <div className='flex flex-col gap-4 w-full max-w-md items-center'>
            <div className="flex justify-center">
              <LanguageSwitcher />
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </Fragment>;
};

// AuthBrandedLayout component that wraps the Layout component with AuthBrandedLayoutProvider
const AuthBrandedLayout = () => <AuthBrandedLayoutProvider>
    <Layout />
  </AuthBrandedLayoutProvider>;
export { AuthBrandedLayout };